import React from 'react';
import { motion } from 'framer-motion';
import { SunIcon, MoonIcon } from 'lucide-react';
import { useTheme } from './ThemeProvider';
/**
 * Animated light/dark segmented toggle used in the footer.
 * A sliding knob moves between the sun and moon; icons crossfade.
 */
export function ThemeToggle() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  const isLight = theme === 'light';
  return <button type="button" onClick={toggleTheme} role="switch" aria-checked={isLight} aria-label={isLight ? 'Switch to dark mode' : 'Switch to light mode'} className="theme-toggle group relative inline-flex items-center gap-2 rounded-full border border-line-2 bg-raise-2 p-1 pl-1 pr-3 text-mut hover:text-ink hover:border-lime/50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime transition-colors" data-id="element-281">
      {/* Track with sliding knob */}
      <span className="relative flex h-7 w-[3.75rem] items-center rounded-full bg-canvas/60 border border-line" data-id="element-282">
        <motion.span className="absolute top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full bg-lime text-white shadow-sm" initial={false} animate={{
        left: isLight ? '2px' : 'calc(100% - 26px)'
      }} transition={{
        type: 'spring',
        stiffness: 500,
        damping: 32
      }} data-id="element-283">
          <motion.span key={theme} initial={{
          rotate: -90,
          opacity: 0,
          scale: 0.6
        }} animate={{
          rotate: 0,
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.25,
          ease: [0.2, 0.7, 0.2, 1]
        }} className="flex items-center justify-center" data-id="element-284">
            {isLight ? <SunIcon size={14} data-id="element-285" /> : <MoonIcon size={14} data-id="element-286" />}
          </motion.span>
        </motion.span>
        {/* Static rail icons for affordance */}
        <SunIcon size={13} className={`absolute left-[7px] top-1/2 -translate-y-1/2 transition-opacity ${isLight ? 'opacity-0' : 'opacity-60'}`} aria-hidden="true" data-id="element-287" />
        <MoonIcon size={13} className={`absolute right-[7px] top-1/2 -translate-y-1/2 transition-opacity ${isLight ? 'opacity-60' : 'opacity-0'}`} aria-hidden="true" data-id="element-288" />
      </span>
      <span className="text-[13px] font-mono" data-id="element-289">
        {isLight ? 'Light' : 'Dark'}
      </span>
    </button>;
}